var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pagesCount > 1)?_c('b-pagination-nav',{attrs:{"link-gen":_vm.linkGen,"number-of-pages":_vm.pagesCount,"value":_vm.currentPage,"use-router":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }